import { render, staticRenderFns } from "./AssignProductsStockStore.vue?vue&type=template&id=320b7abb"
import script from "./AssignProductsStockStore.vue?vue&type=script&lang=js"
export * from "./AssignProductsStockStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports